import { render, staticRenderFns } from "./FormComponentPrevInspection.vue?vue&type=template&id=63c88b24"
import script from "./FormComponentPrevInspection.vue?vue&type=script&lang=js"
export * from "./FormComponentPrevInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports